import { render, staticRenderFns } from "./TripLegsDialog.vue?vue&type=template&id=7b378aa8"
import script from "./TripLegsDialog.vue?vue&type=script&lang=js"
export * from "./TripLegsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports